import { jsxs as s, Fragment as x, jsx as r } from "react/jsx-runtime";
import { clsx as d } from "../../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { useDisclosure as I } from "../../../utils/use-disclosure.js";
import { RocheUIBadge as y } from "../../badge/roche-badge.js";
import { RocheUIIcon as C } from "../../icon/roche-icon.js";
import a from "./roche-pharma-card.module.scss.js";
import { rocheUIPharmaCardVariantBadgeColor as P, RocheUIPharmaCardVariant as R } from "./roche-pharma-card.types.js";
const b = ({
  name: t,
  genericName: h,
  indicationShort: p,
  label: m,
  variant: i = R.OTHER,
  reducedOpacity: _ = !1,
  open: c = !1,
  onToggle: e,
  children: N,
  phaseLabel: l,
  labelHidden: f = !1
}) => {
  const n = !!e, { triggerProps: u, panelProps: v } = I(c), o = /* @__PURE__ */ s(x, { children: [
    l && /* @__PURE__ */ r("span", { className: a["pharma-card__visually-hidden"], children: l }),
    m && (f ? /* @__PURE__ */ r("span", { className: a["pharma-card__visually-hidden"], children: m }) : /* @__PURE__ */ r("span", { className: a["pharma-card__badge"], children: /* @__PURE__ */ r(y, { text: m, color: P[i] }) })),
    /* @__PURE__ */ s("span", { className: a["pharma-card__names"], children: [
      /* @__PURE__ */ r("span", { className: a["pharma-card__name"], children: t }),
      h && /* @__PURE__ */ r("span", { className: a["pharma-card__generic-name"], children: h })
    ] }),
    p && /* @__PURE__ */ s("span", { className: a["pharma-card__indication-row"], children: [
      /* @__PURE__ */ r("span", { className: a["pharma-card__indication"], children: p }),
      n && /* @__PURE__ */ r(
        "span",
        {
          className: d(a["pharma-card__toggle-icon"], c && a["pharma-card__toggle-icon--open"]),
          children: /* @__PURE__ */ r(C, { icon: "chevron-down", height: "24px", decorative: !0 })
        }
      )
    ] })
  ] });
  return /* @__PURE__ */ s(
    "div",
    {
      className: d(
        a["pharma-card"],
        a[`pharma-card--${i}`],
        _ && a["pharma-card--reduced-opacity"]
      ),
      children: [
        n ? /* @__PURE__ */ r(
          "button",
          {
            type: "button",
            className: d(a["pharma-card__header"], a["pharma-card__toggle"]),
            onClick: () => e == null ? void 0 : e(!c),
            ...u,
            children: o
          }
        ) : /* @__PURE__ */ r("div", { className: a["pharma-card__header"], children: o }),
        n && /* @__PURE__ */ r("div", { className: d(a["pharma-card__panel"], c && a["pharma-card__panel--open"]), ...v, children: /* @__PURE__ */ r("div", { className: a["pharma-card__panel-content"], children: N }) })
      ]
    }
  );
};
export {
  b as RocheUIPharmaCard
};
